var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockpick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.005 512.005",
    style: {
      width: 20,
      height: 20
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M256.003 234.672c-11.76 0-21.333 9.573-21.333 21.333 0 7.792 4.409 14.329 10.667 18.053v13.947a10.66 10.66 0 0010.667 10.667 10.66 10.66 0 0010.667-10.667v-13.947c6.258-3.724 10.667-10.262 10.667-18.053-.002-11.76-9.575-21.333-21.335-21.333zM256.003 149.339c-17.646 0-32 14.354-32 32v10.667h64v-10.667c0-17.646-14.355-32-32-32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M440.888 64.609l-181.333-64a10.65 10.65 0 00-7.104 0l-181.333 64a10.683 10.683 0 00-7.115 10.063v128c0 165.646 24.563 226.188 187.198 308.188 1.51.76 3.156 1.146 4.802 1.146a10.67 10.67 0 004.802-1.146c162.635-82 187.198-142.542 187.198-308.188v-128c0-4.521-2.855-8.552-7.115-10.063zm-88.885 255.396c0 11.76-9.573 21.333-21.333 21.333H181.336c-11.76 0-21.333-9.573-21.333-21.333V213.339c0-11.76 9.573-21.333 21.333-21.333v-10.667c0-41.167 33.5-74.667 74.667-74.667s74.667 33.5 74.667 74.667v10.667c11.76 0 21.333 9.573 21.333 21.333v106.666z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockpick);
export default __webpack_public_path__ + "static/media/lockpick.27dc9156aff1a4d9ef24f5c9a337cb4f.svg";
export { ForwardRef as ReactComponent };